export const jobTypesFieldLabelProps = {
    label: 'Search by Job Type and Flexibility',
    shouldShowTooltip: false,
};

export const SEARCH_API = '/api/company/flexibility-stats-and-comments';

export const removeLabel = ({ value }) => value;

export const jobTypesMap = {
    work_from_home: 'Remote Jobs',
    part_time: 'Part-Time Jobs',
    flexible: 'Flexible Schedule Available',
};

export const buildJobTypesString = (str, { value }) => {
    const separator = str ? '+' : '';
    return `${str}${separator}${value}`;
};

export const buildJobTypesQuery = (jobTypes) =>
    jobTypes.reduce(buildJobTypesString, '');

export const convertToArray = (string) => {
    if (!string) {
        return [];
    }

    return string
        .split(' ')
        .map((type) => ({ label: jobTypesMap[type], value: type }));
};

export const TABLE_HEADERS = [
    {
        label: 'Name',
        sortOptions: [
            { label: 'A - Z', value: 'asc' },
            { label: 'Z - A', value: 'desc' },
        ],
        value: 'companyName',
    },
    {
        label: 'Industry',
        sortOptions: [
            { label: 'A - Z', value: 'asc' },
            { label: 'Z - A', value: 'desc' },
        ],
        value: 'industry',
    },
    {
        label: 'Types of Jobs',
        value: 'jobTypes',
    },
    {
        label: 'Comments',
        value: 'comments',
    },
    {
        label: 'Add a Tip',
    },
];

export const mapJobTypes = (jobType) => {
    return jobTypesMap[jobType];
};

export const PAGE_LIMIT = 20;
export const THROTTLE_INTERVAL = 200;
